var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhonepeSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 23.5,
    rx: 5.75,
    stroke: "#DEDEDE",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "#5F259F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5362 9.39025C16.5362 8.99933 16.201 8.66409 15.8101 8.66409H14.4694L11.3969 5.14468C11.1176 4.80944 10.6707 4.69779 10.2238 4.80944L9.16243 5.14468C8.99482 5.20065 8.93884 5.42395 9.05079 5.53559L12.4026 8.72006H7.31833C7.15071 8.72006 7.03906 8.83171 7.03906 8.99933V9.55787C7.03906 9.94878 7.3743 10.284 7.76522 10.284H8.54734V12.9656C8.54734 14.9768 9.60873 16.1501 11.3966 16.1501C11.9551 16.1501 12.4023 16.0941 12.9608 15.8708V17.6587C12.9608 18.1615 13.3517 18.5524 13.8546 18.5524H14.6367C14.8043 18.5524 14.972 18.3848 14.972 18.2172V10.2283H16.2569C16.4246 10.2283 16.5362 10.1167 16.5362 9.94908V9.39025ZM12.9608 14.1946C12.6256 14.3623 12.1787 14.4182 11.8435 14.4182C10.9497 14.4182 10.5028 13.9713 10.5028 12.9656V10.284H12.9608V14.1946Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonepeSquare);
export default __webpack_public_path__ + "static/media/phonepe-square.b875739e0daaf7b36741f9a07c0a6297.svg";
export { ForwardRef as ReactComponent };